module.exports = __webpack_public_path__ + "media/images/front/icon_post-743319eaf1a100dd6f88a5a63ef2d172.png";